module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG0001-f80d158d0915a2c0ed30e816a3f46576.png";